import httpClient from '../utils/http'
import { handleResponseAsync } from '../utils/HelperUtils'
import { normalize } from 'normalizr'
import { templatesSchema } from './../entities/schema'
import _ from 'lodash'

export const templateService = {
    getTemplates,
    updateTemplate,
    addTemplate,
    removeTemplateById,
}

function convertViewModelList(data) {
    const templateListSchema = [templatesSchema]
    const normalizedData = normalize(data, templateListSchema)
    return normalizedData.entities
}

function convertViewModel(data, update) {

    if(update){
        const normalizedData = normalize(_.head(data), templatesSchema)
        return normalizedData.entities
    } else{
        const normalizedData = normalize(data, templatesSchema)
        return normalizedData.entities
    }
    
}

function convertById(data) {
    return data.id;
  }

function getTemplates() {
    const url = '/api/template'

    return httpClient
        .get(url)
        .then(handleResponseAsync)
        .then(res => convertViewModelList(res.data))
}

function updateTemplate(data) {
    const url = '/api/template'

    return httpClient
        .put(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data, true))
}

function addTemplate(data) {
    const url = '/api/template'
    
    return httpClient
        .post(url, data)
        .then(handleResponseAsync)
        .then(res => convertViewModel(res.data))
}

function removeTemplateById(id) {
    const url = `/api/template/${id}`

    return httpClient
        .delete(url)
        .then(handleResponseAsync)
        .then(res => convertById(res.data))
}
